import { Modal } from "@/components/atoms";
import { ClientsCancelInvite } from "./components/ClientsCancelInvite";
import { ClientsReactivate } from "./components/ClientsReactivate";
import { ClientsRemoveAccess } from "./components/ClientsRemoveAccess";
import { ClientsResendInvite } from "./components/ClientsResendInvite";
import { ClientsUploadConfirm } from "./components/ClientsUploadConfirm";
import { useClientsContext } from "./context";
import { InviteClientsModal } from "./modals/InviteClientsModal";

export const ClientsModals = () => {
  const { step, setStep, setSelectedClient } = useClientsContext();

  const onClientActionClose = () => {
    setStep(undefined);
    setSelectedClient(undefined);
  };

  return (
    <>
      <Modal open={step === "remove-access"} onClose={onClientActionClose} className="max-w-[514px]">
        <ClientsRemoveAccess onClose={onClientActionClose} />
      </Modal>

      <Modal open={step === "reactivate"} onClose={onClientActionClose} className="max-w-[514px]">
        <ClientsReactivate onClose={onClientActionClose} />
      </Modal>

      <Modal open={step === "resend-invite"} onClose={onClientActionClose} className="max-w-[514px]">
        <ClientsResendInvite onClose={onClientActionClose} />
      </Modal>

      <Modal open={step === "cancel-invite"} onClose={onClientActionClose} className="max-w-[514px]">
        <ClientsCancelInvite onClose={onClientActionClose} />
      </Modal>

      <Modal open={step === "upload-confirm"} onClose={() => setStep(undefined)} className="max-w-[514px]">
        <ClientsUploadConfirm onClose={() => setStep(undefined)} />
      </Modal>

      <InviteClientsModal open={step === "invite"} onClose={() => setStep(undefined)} />
    </>
  );
};
